import styled from '@emotion/styled';
import { Checkbox } from 'src/web/components/Checkbox/component';

export const StyledCheckbox = styled(Checkbox)({
  marginTop: 8,
  marginBottom: 16,
});
